const showSocial = document.getElementsByClassName("social-position")[0];

showSocial?.setAttribute("class", "block");
